import { GoogleReCaptchaProvider, useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { Form, FlexboxGrid, InputGroup, toaster, Message, Schema } from 'rsuite';
import { useHistory } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { FormEvent, useCallback, useState } from 'react';
import { getByUserName } from 'services/microsoftGraphApi';
import { siteVerify } from 'services/googleRecaptcha';
import SearchIcon from '@rsuite/icons/Search';
import CryptoJS from 'crypto-js';
import ClipLoader from 'react-spinners/ClipLoader';
import React from 'react';

const regexMail = /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i;
const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY + '';

export default function RecuperarContrasena(): React.ReactElement {
  return (
    <GoogleReCaptchaProvider language="es-CL" reCaptchaKey={recaptchaKey} scriptProps={{ async: true }}>
      <RecuperarContrasena2 />
    </GoogleReCaptchaProvider>
  );
}

function RecuperarContrasena2(): React.ReactElement {

  let [value, setValue] = useState("");
  const [isDisabled, setDisibility] = useState(true);
  const [loadingInProgress, setLoading] = useState(false);
  const { executeRecaptcha } = useGoogleReCaptcha();

  const { StringType } = Schema.Types;
  const model = Schema.Model({
    email: StringType().isRequired('Este campo es requerido').isEmail('Por favor, ingrese un correo válido.')
  });

  const styles = {
    width: 300,
    marginBottom: 10
  };  

  const history = useHistory();

  const handleChange = (val) => {
    setDisibility(!regexMail.test(val));
    setValue(val);
    value = val;
  };  

  const onSubmit = useCallback(
    (event: FormEvent) => {
      event.preventDefault();

      if (!executeRecaptcha) return;
      (async () => {
        try {
          const token = await executeRecaptcha('callMicrosoftGraphAPI');

          if (token != null && token != undefined && token != '')
          {
            const respuesta = await siteVerify(token);

            if (respuesta.success && respuesta.score != null && respuesta.score >= 0.5)
            {
              const value2 = document.querySelector('#email') as HTMLInputElement;

              setValue(value2.value);

              callMicrosoftGraphAPI(value2.value);
            }
            else
            {
              toaster.push(
                <Message showIcon type="warning" header="Atención" duration={4000}>
                    No se pudo validar el token de recaptcha. Intente nuevamente.
                </Message>, { placement: 'topEnd' });
            }
          }
          else
          {
            toaster.push(
            <Message showIcon type="warning" header="Atención" duration={4000}>
                No se pudo obtener un token de recaptcha
            </Message>, { placement: 'topEnd' });
          }

        } catch (e) {
          toaster.push(
          <Message showIcon type="warning" header="Atención" duration={4000}>
              No se pudo obtener un token de recaptcha
          </Message>, { placement: 'topEnd' });
        }
      })();
    },
    [executeRecaptcha]
  );  

  const callMicrosoftGraphAPI = async (value) => {
    
    if (value == null || value == '') 
    {
      toaster.push(
      <Message showIcon type="warning" header="Atención" duration={4000}>
          Debe ingresar la cuenta usuario colaborador antes de continuar.
      </Message>, { placement: 'topEnd' });
    }
    else 
    {
      setLoading(true);

      const respuesta = await getByUserName(value);

      if (respuesta.success && respuesta.data.id != null)
      {
        setLoading(false);

        // Encrypt
        var ciphertext = CryptoJS.AES.encrypt(JSON.stringify(respuesta.data.id), 'my-secret-key@123').toString();

        let path = '/opciones/' + ciphertext.toString();
        history.push(path);
      }
      else 
      {
        setLoading(false);
        
        setValue("");

        toaster.push(
        <Message showIcon type="warning" header="Atención" duration={4000}>
            La cuenta usuario colaborador ingresada no fue encontrada
        </Message>, { placement: 'topEnd' });          
      }
    }
  };
    
  const renderRecuperarContrasena = (
    <Form model={model}>
      <Form.Group controlId="email">
        <Form.ControlLabel>Cuenta Usuario Colaborador</Form.ControlLabel>
        <InputGroup style={styles}>
          <Form.Control onChange={handleChange} value={value} name='email' label='Cuenta Usuario Colaborador'/>                     
          <InputGroup.Button type='submit' disabled={isDisabled} onClick={onSubmit}>
            <SearchIcon />
          </InputGroup.Button>              
        </InputGroup>
      </Form.Group>
    </Form>
  );

  return (
    <FlexboxGrid justify="center" align="middle" style={{ marginTop: '5%', backgroundColor: '#FFF' }}>
      {loadingInProgress ? (<ClipLoader color={'#000000'} size={150} />) : (renderRecuperarContrasena)}      
    </FlexboxGrid>
  );    
}